import { render, staticRenderFns } from "./CreateUpload.vue?vue&type=template&id=187d3696&scoped=true"
import script from "./CreateUpload.vue?vue&type=script&lang=js"
export * from "./CreateUpload.vue?vue&type=script&lang=js"
import style0 from "./CreateUpload.vue?vue&type=style&index=0&id=187d3696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187d3696",
  null
  
)

export default component.exports